import { render } from "./country-create.vue?vue&type=template&id=bcdf05d6"
import script from "./country-create.vue?vue&type=script&lang=js"
export * from "./country-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__